import React from "react";
import AdminComponent from "../components/AdminComponent";

const Admin = () => {
  return (
    <div>
      <AdminComponent />
    </div>
  );
};

export default Admin;
